import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import ability from '@/libs/acl/ability'
import { canNavigate } from '@/libs/acl/routeProtection'
import { buildAbilityRules } from '@/libs/acl/abilityRules'
import administration from './administration'
import membership from './membership'
import auth from './auth'
import contribution from './contribution'
import documents from './documents'
import dashboard from './dashboard'
import farmManager from './farm-manager'
import employeeCentre from './employee-centre'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        redirectIfGuest: true,
      },
    },
    ...auth,
    ...administration,
    ...membership,
    ...contribution,
    ...documents,
    ...dashboard,
    ...farmManager,
    ...employeeCentre,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/dues-payment',
      name: 'dues-payment',
      component: () => import('@/views/DuesPayment.vue'),
      meta: {
        layout: 'full',
        allow: true,
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

let abilitiesHydrated = false

router.beforeEach(async (to, _, next) => {
  await store.restored

  if (!abilitiesHydrated) {
    const user = store.state.auth.user || {}
    ability.update(buildAbilityRules(user))
    abilitiesHydrated = true
  }

  if (to.meta.allow) {
    return next()
  }

  const isLoggedIn = store.getters['auth/isLoggedIn']

  if (to.meta.redirectIfGuest && !isLoggedIn) {
    return next({ name: 'login' })
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn && !store.getters['auth/isSuperUser']) {
    return next('/')
  }

  if (isLoggedIn && !canNavigate(to)) {
    return next({ name: 'home' })
  }

  return next()
})

export default router
